import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AppTimelinePageStyled, DashboardPanel, Header, Wrapper } from './styled';
import DashboardTabs from '@src/components/common/Dashboard/DashboardTabs';
import { Select } from 'antd';
import Search from 'antd/es/input/Search';
import { SearchHelpText } from './SearchHelpText';
import { idOptions } from './constants';
import { useDispatch } from 'react-redux';
import { getAppViewerModuleTempDashboardUrl } from '@src/components/common/Dashboard/utils/getTempDashboardUrl';
import { createTempDashboard } from '@src/store/tempDashboard/actions';
import { DASHBOARD_TYPE } from '@src/utils/constants';
import { EQueryIdType } from './types';

const AppTimelineInitPage = () => {
  const [idType, setIdType] = useState<EQueryIdType>(EQueryIdType.userId);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const flowId = search.get('flowId') ?? undefined;

  const handleOnSearch = (v) => {
    if (!v?.trim()) {
      return;
    }
    let viewerId;
    let clientId;
    let dashboardTitle = 'User';
    if (idType === EQueryIdType.userId) {
      viewerId = v;
    } else if (idType === EQueryIdType.clientId) {
      clientId = v;
      dashboardTitle = 'Client';
    }
    const redirectHandler = ({ id: tabId }) => {
      navigate(getAppViewerModuleTempDashboardUrl({ viewerId, clientId, flowId }, tabId));
    };
    dispatch(
      createTempDashboard(
        DASHBOARD_TYPE.APP_VIEWER_MODULE,
        { viewerId, clientId, flowId },
        `${dashboardTitle} - ${v}`,
        {
          redirectHandler,
        },
      ),
    );
  };

  return (
    <AppTimelinePageStyled>
      <Wrapper>
        <DashboardPanel>
          <DashboardTabs />
        </DashboardPanel>
        <Header>
          <Search
            addonBefore={
              <Select
                defaultValue={EQueryIdType.userId}
                options={idOptions}
                onChange={setIdType}
                value={idType}
              />
            }
            placeholder={
              idType === EQueryIdType.userId ? 'Please input a User ID' : 'Please input a Client ID'
            }
            allowClear
            onSearch={handleOnSearch}
            style={{ width: 500 }}
          />
        </Header>
        <SearchHelpText />
      </Wrapper>
    </AppTimelinePageStyled>
  );
};

export default AppTimelineInitPage;
